import { render, staticRenderFns } from "./TopbarUserDropdown.vue?vue&type=template&id=3347d94e&scoped=true&"
import script from "./TopbarUserDropdown.vue?vue&type=script&lang=js&"
export * from "./TopbarUserDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TopbarUserDropdown.vue?vue&type=style&index=0&id=3347d94e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347d94e",
  null
  
)

export default component.exports